module.exports = __webpack_public_path__ + "img/7esty blaCK ARABIC@3x.77252711.png";